(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('utente', {
            parent: 'entity',
            url: '/utente?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.utente.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/utente/utentes.html',
                    controller: 'UtenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('utente');
                    $translatePartialLoader.addPart('tipoSesso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('utente-detail', {
            parent: 'entity',
            url: '/utente/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.utente.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/utente/utente-detail.html',
                    controller: 'UtenteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('utente');
                    $translatePartialLoader.addPart('tipoSesso');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Utente', function($stateParams, Utente) {
                    return Utente.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'utente',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('utente-detail.edit', {
            parent: 'utente-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('utente.new', {
            parent: 'utente',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sesso: null,
                                titolo: null,
                                titoloLavorativo: null,
                                sezione: null,
                                firma: null,
                                firmaContentType: null,
                                direttore: false,
                                dataInizioDirezione: null,
                                dataFineDirezione: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('utente');
                });
            }]
        })
        .state('utente.edit', {
            parent: 'utente',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('utente.delete', {
            parent: 'utente',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-delete-dialog.html',
                    controller: 'UtenteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
